import React, { useState } from "react";
import Section from "./components/Section";
import Questions from "./components/Questions";
import BackButton from "../../components/button/BackButton";
import { useLocation } from "react-router-dom";

const ViewService = () => {
  const { state } = useLocation();
  const [selectedSection, setSelectedSection] = useState(null);

  return (
    <div>
      <div className="flex items-center gap-3 mb-5">
        <BackButton />
        <h2 className="title">{state?.service}</h2>
      </div>

      <div className="grid xl:grid-cols-4 gap-4">
        <Section
          selectedSection={selectedSection}
          setSelectedSection={setSelectedSection}
        />

        <div className="xl:col-span-3">
          <Questions
            selectedSection={selectedSection}
            setSelectedSection={setSelectedSection}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewService;
